import { LRParser } from '@lezer/lr';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf$1 = 147,
  nan$1 = 148,
  Bool$1 = 1,
  Ignoring$1 = 2,
  On$1 = 3,
  GroupLeft$1 = 4,
  GroupRight$1 = 5,
  Offset$1 = 6,
  Atan2$1 = 7,
  Avg$1 = 8,
  Bottomk$1 = 9,
  Count$1 = 10,
  CountValues$1 = 11,
  Group$1 = 12,
  Max$1 = 13,
  Min$1 = 14,
  Quantile$1 = 15,
  Stddev$1 = 16,
  Stdvar$1 = 17,
  Sum$1 = 18,
  Topk$1 = 19,
  By$1 = 20,
  Without$1 = 21,
  And$1 = 22,
  Or$1 = 23,
  Unless$1 = 24,
  Start$1 = 25,
  End$1 = 26;

// Copyright 2021 The Prometheus Authors

const keywordTokens = {
    inf: inf$1,
    nan: nan$1,
    bool: Bool$1,
    ignoring: Ignoring$1,
    on: On$1,
    group_left: GroupLeft$1,
    group_right: GroupRight$1,
    offset: Offset$1,
};

const specializeIdentifier = (value, stack) => {
    return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens = {
    avg: Avg$1,
    atan2: Atan2$1,
    bottomk: Bottomk$1,
    count: Count$1,
    count_values: CountValues$1,
    group: Group$1,
    max: Max$1,
    min: Min$1,
    quantile: Quantile$1,
    stddev: Stddev$1,
    stdvar: Stdvar$1,
    sum: Sum$1,
    topk: Topk$1,
    by: By$1,
    without: Without$1,
    and: And$1,
    or: Or$1,
    unless: Unless$1,
    start: Start$1,
    end: End$1,
};

const extendIdentifier = (value, stack) => {
    return contextualKeywordTokens[value.toLowerCase()] || -1;
};

// Copyright 2022 The Prometheus Authors

const promQLHighLight = styleTags({
    LineComment: tags.comment,
    LabelName: tags.labelName,
    StringLiteral: tags.string,
    NumberLiteral: tags.number,
    Duration: tags.number,
    Identifier: tags.variableName,
    'Abs Absent AbsentOverTime Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp Floor HistogramCount HistogramFraction HistogramQuantile HistogramSum HoltWinters Hour Idelta Increase Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MaxOverTime MinOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Time Timestamp Vector Year':
        tags.function(tags.variableName),
    'Avg Bottomk Count Count_values Group Max Min Quantile Stddev Stdvar Sum Topk': tags.operatorKeyword,
    'By Without Bool On Ignoring GroupLeft GroupRight Offset Start End': tags.modifier,
    'And Unless Or': tags.logicOperator,
    'Sub Add Mul Mod Div Atan2 Eql Neq Lte Lss Gte Gtr EqlRegex EqlSingle NeqRegex Pow At': tags.operator,
    UnaryOp: tags.arithmeticOperator,
    '( )': tags.paren,
    '[ ]': tags.squareBracket,
    '{ }': tags.brace,
    '⚠': tags.invalid,
});

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_Identifier = {__proto__:null,absent_over_time:313, absent:315, abs:317, acos:319, acosh:321, asin:323, asinh:325, atan:327, atanh:329, avg_over_time:331, ceil:333, changes:335, clamp:337, clamp_max:339, clamp_min:341, cos:343, cosh:345, count_over_time:347, days_in_month:349, day_of_month:351, day_of_week:353, day_of_year:355, deg:357, delta:359, deriv:361, exp:363, floor:365, histogram_count:367, histogram_fraction:369, histogram_quantile:371, histogram_sum:373, holt_winters:375, hour:377, idelta:379, increase:381, irate:383, label_replace:385, label_join:387, last_over_time:389, ln:391, log10:393, log2:395, max_over_time:397, min_over_time:399, minute:401, month:403, pi:405, predict_linear:407, present_over_time:409, quantile_over_time:411, rad:413, rate:415, resets:417, round:419, scalar:421, sgn:423, sin:425, sinh:427, sort:429, sort_desc:431, sqrt:433, stddev_over_time:435, stdvar_over_time:437, sum_over_time:439, tan:441, tanh:443, timestamp:445, time:447, vector:449, year:451};
const parser = LRParser.deserialize({
  version: 14,
  states: "7pOYQPOOO'XQPOOOOQO'#Cz'#CzO'^QPO'#CyQ'iQQOOOOQO'#Da'#DaO'dQPO'#D`OOQO'#E}'#E}O(vQPO'#FTOYQPO'#FPOYQPO'#FSO/OQSO'#FVO/WQQO'#FUOOQO'#FU'#FUOOQO'#Fi'#FiOOQO'#Db'#DbOOQO'#Dd'#DdOOQO'#De'#DeOOQO'#Df'#DfOOQO'#Dg'#DgOOQO'#Dh'#DhOOQO'#Di'#DiOOQO'#Dj'#DjOOQO'#Dk'#DkOOQO'#Dl'#DlOOQO'#Dm'#DmOOQO'#Dn'#DnOOQO'#Do'#DoOOQO'#Dp'#DpOOQO'#Dq'#DqOOQO'#Dr'#DrOOQO'#Ds'#DsOOQO'#Dt'#DtOOQO'#Du'#DuOOQO'#Dv'#DvOOQO'#Dw'#DwOOQO'#Dx'#DxOOQO'#Dy'#DyOOQO'#Dz'#DzOOQO'#D{'#D{OOQO'#D|'#D|OOQO'#D}'#D}OOQO'#EO'#EOOOQO'#EP'#EPOOQO'#EQ'#EQOOQO'#ER'#EROOQO'#ES'#ESOOQO'#ET'#ETOOQO'#EU'#EUOOQO'#EV'#EVOOQO'#EW'#EWOOQO'#EX'#EXOOQO'#EY'#EYOOQO'#EZ'#EZOOQO'#E['#E[OOQO'#E]'#E]OOQO'#E^'#E^OOQO'#E_'#E_OOQO'#E`'#E`OOQO'#Ea'#EaOOQO'#Eb'#EbOOQO'#Ec'#EcOOQO'#Ed'#EdOOQO'#Ee'#EeOOQO'#Ef'#EfOOQO'#Eg'#EgOOQO'#Eh'#EhOOQO'#Ei'#EiOOQO'#Ej'#EjOOQO'#Ek'#EkOOQO'#El'#ElOOQO'#Em'#EmOOQO'#En'#EnOOQO'#Eo'#EoOOQO'#Ep'#EpOOQO'#Eq'#EqOOQO'#Er'#ErOOQO'#Es'#EsOOQO'#Et'#EtOOQO'#Eu'#EuOOQO'#Ev'#EvOOQO'#Ew'#EwOOQO'#Ex'#ExOOQO'#Ey'#EyOOQO'#Ez'#EzQOQPOOO0qQPO'#C{O0vQPO'#DOO'dQPO,59eO0}QQO,59eO2kQPO,59kO2kQPO,59kO2kQPO,59kO2kQPO,59kO2kQPO,59kO8sQQO,5;gO8xQQO,5;jO9QQPO,5;wOOQO,59z,59zOOQO,5;i,5;iO9iQQO,5;kO9pQQO,5;nO;WQPO'#FWOOQO,5;q,5;qO;fQPO,5;qOOQO,5;p,5;pO;nQSO'#C|OOQO,59g,59gOOQO,59j,59jO;vQQO,59jOOQO1G/P1G/POOQO'#DR'#DRO0qQPO'#DSOOQO'#Fm'#FmO<QQPO'#FmOYQPO1G/VOYQPO1G/VOYQPO1G/VOYQPO1G/VOYQPO1G/VOBVQSO1G1ROOQO1G1U1G1UOB_QQO1G1UOBdQPO'#E}OOQO'#F_'#F_OOQO1G1c1G1cOBoQPO1G1cOOQO1G1V1G1VOOQO'#FX'#FXOBtQPO,5;rOByQSO1G1]OCRQPO1G1]OOQO1G1]1G1]OOQO,59h,59hOCZQPO,59hOYQPO'#FbOCcQPO1G/UOOQO1G/U1G/UOCkQPO,59nOOQO,5<X,5<XOJzQQO7+$qOK[QQO7+$qOLpQQO7+$qOMWQQO7+$qONoQQO7+$qOOQO7+&m7+&mO! YQQO7+&sOOQO7+&p7+&pO! bQPO7+&}OOQO1G1^1G1^OOQO,5;},5;}OOQO7+&w7+&wO! gQSO7+&wOOQO-E9a-E9aO! oQSO1G/SO! wQPO1G/SOOQO1G/S1G/SO!!PQQO,5;|OOQO-E9`-E9`OOQO7+$p7+$pO!!ZQPO1G/YOOQO<<J_<<J_O!(YQPO<<J_OOQO<<Ji<<JiOOQO<<Jc<<JcP!(_QSO'#FcOOQO,5;{,5;{OOQO7+$n7+$nO!(dQSO7+$nOOQO-E9_-E9_OOQO7+$t7+$tOOQOAN?yAN?yOOQO<<HY<<HYP!(lQSO'#Fa",
  stateData: "!(q~O$[OSkOS~OWQOXQOYQOZQO[QO]QO^QO_QO`QOaQObQOcQO!V[O#t^O$XVO$YVO$^XO$b_O$c`O$daO$ebO$fcO$gdO$heO$ifO$jgO$khO$liO$mjO$nkO$olO$pmO$qnO$roO$spO$tqO$urO$vsO$wtO$xuO$yvO$zwO${xO$|yO$}zO%O{O%P|O%Q}O%R!OO%S!PO%T!QO%U!RO%V!SO%W!TO%X!UO%Y!VO%Z!WO%[!XO%]!YO%^!ZO%_![O%`!]O%a!^O%b!_O%c!`O%d!aO%e!bO%f!cO%g!dO%h!eO%i!fO%j!gO%k!hO%l!iO%m!jO%n!kO%o!lO%p!mO%q!nO%r!oO%s!pO%t!qO%u!rO%v!sO%w!tO%x!uO%y!vO%|WO%}WO&OVO&QZO~O!V!wO~Od!xOe!xO$^!yO~OU#SOV!|Of#POg#QOh#POt!|Ow!|Ox!|Oy!|Oz!}O{!}O|#OO}#OO!O#OO!P#OO!Q#OO!R#OO$Q#TO%z#RO~O$X#VO$Y#VO&O#VOW#wXX#wXY#wXZ#wX[#wX]#wX^#wX_#wX`#wXa#wXb#wXc#wX!V#wX#t#wX$X#wX$Y#wX$^#wX$b#wX$c#wX$d#wX$e#wX$f#wX$g#wX$h#wX$i#wX$j#wX$k#wX$l#wX$m#wX$n#wX$o#wX$p#wX$q#wX$r#wX$s#wX$t#wX$u#wX$v#wX$w#wX$x#wX$y#wX$z#wX${#wX$|#wX$}#wX%O#wX%P#wX%Q#wX%R#wX%S#wX%T#wX%U#wX%V#wX%W#wX%X#wX%Y#wX%Z#wX%[#wX%]#wX%^#wX%_#wX%`#wX%a#wX%b#wX%c#wX%d#wX%e#wX%f#wX%g#wX%h#wX%i#wX%j#wX%k#wX%l#wX%m#wX%n#wX%o#wX%p#wX%q#wX%r#wX%s#wX%t#wX%u#wX%v#wX%w#wX%x#wX%y#wX%|#wX%}#wX&O#wX&Q#wX~Oq#YO&R#ZO~O&QZOU#xXV#xXf#xXg#xXh#xXt#xXw#xXx#xXy#xXz#xX{#xX|#xX}#xX!O#xX!P#xX!Q#xX!R#xX$Q#xX$W#xX%z#xX$`#xX$_#xX~O$^#^O~O$`#`O~PYOd!xOe!xOUmaVmafmagmahmatmawmaxmaymazma{ma|ma}ma!Oma!Pma!Qma!Rma$Qma$Wma%zma$`ma$_ma~OP#cOQ#dOR#dOW$aPX$aPY$aPZ$aP[$aP]$aP^$aP_$aP`$aPa$aPb$aPc$aP!V$aP#t$aP$X$aP$Y$aP$^$aP$b$aP$c$aP$d$aP$e$aP$f$aP$g$aP$h$aP$i$aP$j$aP$k$aP$l$aP$m$aP$n$aP$o$aP$p$aP$q$aP$r$aP$s$aP$t$aP$u$aP$v$aP$w$aP$x$aP$y$aP$z$aP${$aP$|$aP$}$aP%O$aP%P$aP%Q$aP%R$aP%S$aP%T$aP%U$aP%V$aP%W$aP%X$aP%Y$aP%Z$aP%[$aP%]$aP%^$aP%_$aP%`$aP%a$aP%b$aP%c$aP%d$aP%e$aP%f$aP%g$aP%h$aP%i$aP%j$aP%k$aP%l$aP%m$aP%n$aP%o$aP%p$aP%q$aP%r$aP%s$aP%t$aP%u$aP%v$aP%w$aP%x$aP%y$aP%|$aP%}$aP&O$aP&Q$aP~O#p#lO~O{#nO#p#mO~Oi#pOj#pO$XVO$YVO%|#oO%}#oO&OVO~O$`#sO~P'iOt!|OU#vaV#vaf#vag#vah#vaw#vax#vay#vaz#va{#va|#va}#va!O#va!P#va!Q#va!R#va$Q#va$W#va%z#va$`#va$_#va~O!R#tO#|#tO#}#tO$O#tO~O$_#vO&R#xO~Oq#zO$`#yO~O$_#{O$`#}O~P'iOQ#dOR#dOW$aXX$aXY$aXZ$aX[$aX]$aX^$aX_$aX`$aXa$aXb$aXc$aX!V$aX#t$aX$X$aX$Y$aX$^$aX$b$aX$c$aX$d$aX$e$aX$f$aX$g$aX$h$aX$i$aX$j$aX$k$aX$l$aX$m$aX$n$aX$o$aX$p$aX$q$aX$r$aX$s$aX$t$aX$u$aX$v$aX$w$aX$x$aX$y$aX$z$aX${$aX$|$aX$}$aX%O$aX%P$aX%Q$aX%R$aX%S$aX%T$aX%U$aX%V$aX%W$aX%X$aX%Y$aX%Z$aX%[$aX%]$aX%^$aX%_$aX%`$aX%a$aX%b$aX%c$aX%d$aX%e$aX%f$aX%g$aX%h$aX%i$aX%j$aX%k$aX%l$aX%m$aX%n$aX%o$aX%p$aX%q$aX%r$aX%s$aX%t$aX%u$aX%v$aX%w$aX%x$aX%y$aX%|$aX%}$aX&O$aX&Q$aX~O%{$VO&P$WO~O#p$XO~O$X#VO$Y#VO&O#VO~O$^$YO~O#t$ZO~Oq#YO&R$]O~O$_$^O&R$]O~O$_$`O$`$bO~O$_#{O$`$eO~OS$fOT$fOWvaXvaYvaZva[va]va^va_va`vaavabvacva!Vva#tva$Xva$Yva$^va$bva$cva$dva$eva$fva$gva$hva$iva$jva$kva$lva$mva$nva$ova$pva$qva$rva$sva$tva$uva$vva$wva$xva$yva$zva${va$|va$}va%Ova%Pva%Qva%Rva%Sva%Tva%Uva%Vva%Wva%Xva%Yva%Zva%[va%]va%^va%_va%`va%ava%bva%cva%dva%eva%fva%gva%hva%iva%jva%kva%lva%mva%nva%ova%pva%qva%rva%sva%tva%uva%vva%wva%xva%yva%|va%}va&Ova&Qva~Ot!|OUsqfsqgsqhsqzsq{sq|sq}sq!Osq!Psq!Qsq!Rsq$Qsq$Wsq%zsq$`sq$_sq~OVsqwsqxsqysq~PIpOV!|Ow!|Ox!|Oy!|O~PIpOV!|Ot!|Ow!|Ox!|Oy!|Oz!}O{!}OUsqfsqgsqhsq$Qsq$Wsq%zsq$`sq$_sq~O|sq}sq!Osq!Psq!Qsq!Rsq~PKlO|#OO}#OO!O#OO!P#OO!Q#OO!R#OO~PKlOV!|Of#POh#POt!|Ow!|Ox!|Oy!|Oz!}O{!}O|#OO}#OO!O#OO!P#OO!Q#OO!R#OO~OUsqgsq$Qsq$Wsq%zsq$`sq$_sq~PMnO#p$hO%{$gO~O$`$iO~Oq#YO&R$jO~Oq$lO$`$mO~O$_$nO$`$mO~O$_$Ua$`$Ua~P'iO$^#^OWviXviYviZvi[vi]vi^vi_vi`viavibvicvi!Vvi#tvi$Xvi$Yvi$bvi$cvi$dvi$evi$fvi$gvi$hvi$ivi$jvi$kvi$lvi$mvi$nvi$ovi$pvi$qvi$rvi$svi$tvi$uvi$vvi$wvi$xvi$yvi$zvi${vi$|vi$}vi%Ovi%Pvi%Qvi%Rvi%Svi%Tvi%Uvi%Vvi%Wvi%Xvi%Yvi%Zvi%[vi%]vi%^vi%_vi%`vi%avi%bvi%cvi%dvi%evi%fvi%gvi%hvi%ivi%jvi%kvi%lvi%mvi%nvi%ovi%pvi%qvi%rvi%svi%tvi%uvi%vvi%wvi%xvi%yvi%|vi%}vi&Ovi&Qvi~O%{$qO~Oq#YO~Oq$lO$`$rO~Oq$lO~O",
  goto: "({$bPPPPPPPPPPPPPPPPPPPPPPPPPPPPP$c$o${%RP%[$cP%e%lPPPPPPPPPPP$c%v&SP&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S&S$cP&`$c$cP$c$c&o$c&{'['dPPP$cP'gP'j'p'vPPPPP'|PPP(le^OXY!y#g#h#i#j#k#{eROXY!y#g#h#i#j#k#{Q!zRR#b!{Q#_!xQ$O#dR$p$fQ!{RQ#UUR#b!zZ#f!|!}#O#P#QY#e!|!}#O#P#QR$P#feUOXY!y#g#h#i#j#k#{eTOXY!y#g#h#i#j#k#{d^OXY!y#g#h#i#j#k#{R#q#TeYOXY!y#g#h#i#j#k#{d]OXY!y#g#h#i#j#k#{R#][Q#[ZV$[#v$^$kR#u#YR#r#TQ$a#zR$o$aQ#|#aR$d#|Q#w#[R$_#wQSOQ#WXQ#XYQ#a!yQ$Q#gQ$R#hQ$S#iQ$T#jQ$U#kR$c#{Q#g!|Q#h!}Q#i#OQ#j#PR#k#Q",
  nodeNames: "⚠ Bool Ignoring On GroupLeft GroupRight Offset Atan2 Avg Bottomk Count CountValues Group Max Min Quantile Stddev Stdvar Sum Topk By Without And Or Unless Start End LineComment PromQL AggregateExpr AggregateOp AggregateModifier GroupingLabels LabelName FunctionCallBody BinaryExpr Pow BoolModifier MatchingModifierClause Mul Div Mod Add Sub Eql Gte Gtr Lte Lss Neq FunctionCall FunctionIdentifier AbsentOverTime Identifier Absent Abs Acos Acosh Asin Asinh Atan Atanh AvgOverTime Ceil Changes Clamp ClampMax ClampMin Cos Cosh CountOverTime DaysInMonth DayOfMonth DayOfWeek DayOfYear Deg Delta Deriv Exp Floor HistogramCount HistogramFraction HistogramQuantile HistogramSum HoltWinters Hour Idelta Increase Irate LabelReplace LabelJoin LastOverTime Ln Log10 Log2 MaxOverTime MinOverTime Minute Month Pi PredictLinear PresentOverTime QuantileOverTime Rad Rate Resets Round Scalar Sgn Sin Sinh Sort SortDesc Sqrt StddevOverTime StdvarOverTime SumOverTime Tan Tanh Timestamp Time Vector Year MatrixSelector Duration NumberLiteral OffsetExpr ParenExpr StringLiteral SubqueryExpr UnaryExpr UnaryOp VectorSelector LabelMatchers LabelMatcher MatchOp EqlSingle EqlRegex NeqRegex StepInvariantExpr At AtModifierPreprocessors MetricName",
  maxTerm: 233,
  nodeProps: [
    ["group", -12,29,35,50,123,125,126,127,128,129,130,132,139,"Expr"]
  ],
  propSources: [promQLHighLight],
  skippedNodes: [0,27],
  repeatNodeCount: 3,
  tokenData: "3s~RwX^#lpq#lqr$ars$tst&luv'Twx'Yxy({yz)Qz{)V{|)[|})c}!O)h!O!P)o!P!Q*o!Q!R*t!R![+l![!]0W!^!_1S!_!`1a!`!a1v!b!c2T!c!}2Y!}#O2p#P#Q2u#Q#R2z#R#S2Y#S#T3P#T#o2Y#o#p3i#q#r3n#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~#qY$[~X^#lpq#l#y#z#l$f$g#l#BY#BZ#l$IS$I_#l$I|$JO#l$JT$JU#l$KV$KW#l&FU&FV#l~$dQ!_!`$j#r#s$o~$oO!R~~$tO$O~~$yW#t~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f<%lO$t~%hO#t~~%kRO;'S$t;'S;=`%t;=`O$t~%yX#t~OY$tZr$trs%cs#O$t#O#P%h#P;'S$t;'S;=`&f;=`<%l$t<%lO$t~&iP;=`<%l$t~&qSk~OY&lZ;'S&l;'S;=`&}<%lO&l~'QP;=`<%l&l~'YOy~~'_W#t~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u<%lO'Y~'zRO;'S'Y;'S;=`(T;=`O'Y~(YX#t~OY'YZw'Ywx%cx#O'Y#O#P'w#P;'S'Y;'S;=`(u;=`<%l'Y<%lO'Y~(xP;=`<%l'Y~)QO$^~~)VO$`~~)[Ow~R)cO%}PzQ~)hO$_~R)oO%|P{QP)rP!Q![)uP)zR&OP!Q![)u!g!h*T#X#Y*TP*WR{|*a}!O*a!Q![*gP*dP!Q![*gP*lP&OP!Q![*g~*tOx~R*yZ&OP!O!P)u!Q![+l!g!h*T#W#X,a#X#Y*T#[#],x#a#b-^#g#h.Q#k#l.c#l#m/l#m#n.}R+qY&OP!O!P)u!Q![+l!g!h*T#W#X,a#X#Y*T#[#],x#a#b-^#g#h.Q#k#l.c#m#n.}Q,fP#pQ!Q![,iQ,lS!Q![,i#[#],x#a#b-^#g#h.QQ,}P#pQ!Q![-QQ-TR!Q![-Q#a#b-^#g#h.QQ-cQ#pQ!Q![-i#g#h-{Q-lR!Q![-i#a#b-u#g#h.QQ-xP#g#h-{Q.QO#pQQ.VP#pQ!Q![.YQ.]Q!Q![.Y#a#b-uQ.hP#pQ!Q![.kQ.nT!Q![.k#W#X,a#[#],x#a#b-^#g#h.QQ/SP#pQ!Q![/VQ/YU!Q![/V#W#X,a#[#],x#a#b-^#g#h.Q#k#l.cP/oR!Q![/x!c!i/x#T#Z/xP/}R&OP!Q![/x!c!i/x#T#Z/xV0_T&PS!VR!Q![0n![!]0n!c!}0n#R#S0n#T#o0nR0sT!VR!Q![0n![!]0n!c!}0n#R#S0n#T#o0n~1XP!Q~!_!`1[~1aO!P~~1fQ#|P!_!`1l#r#s1qQ1qO|Q~1vO#}~~1{P!O~!_!`2O~2TO}~~2YO$Q~V2aT!VRqS!Q![2Y![!]0n!c!}2Y#R#S2Y#T#o2Y~2uO%z~~2zO%{~~3POt~~3STO#S3P#S#T%c#T;'S3P;'S;=`3c<%lO3P~3fP;=`<%l3P~3nO&Q~~3sO&R~",
  tokenizers: [0, 1, 2],
  topRules: {"PromQL":[0,28],"MetricName":[1,142]},
  specialized: [{term: 53, get: (value, stack) => (specializeIdentifier(value) << 1), external: specializeIdentifier},{term: 53, get: (value, stack) => (extendIdentifier(value) << 1) | 1, external: extendIdentifier, extend: true},{term: 53, get: value => spec_Identifier[value] || -1}],
  tokenPrec: 0
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const inf = 147,
  nan = 148,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Atan2 = 7,
  Avg = 8,
  Bottomk = 9,
  Count = 10,
  CountValues = 11,
  Group = 12,
  Max = 13,
  Min = 14,
  Quantile = 15,
  Stddev = 16,
  Stdvar = 17,
  Sum = 18,
  Topk = 19,
  By = 20,
  Without = 21,
  And = 22,
  Or = 23,
  Unless = 24,
  Start = 25,
  End = 26,
  LineComment = 27,
  PromQL = 28,
  AggregateExpr = 29,
  AggregateOp = 30,
  AggregateModifier = 31,
  GroupingLabels = 32,
  LabelName = 33,
  FunctionCallBody = 34,
  BinaryExpr = 35,
  Pow = 36,
  BoolModifier = 37,
  MatchingModifierClause = 38,
  Mul = 39,
  Div = 40,
  Mod = 41,
  Add = 42,
  Sub = 43,
  Eql = 44,
  Gte = 45,
  Gtr = 46,
  Lte = 47,
  Lss = 48,
  Neq = 49,
  FunctionCall = 50,
  FunctionIdentifier = 51,
  AbsentOverTime = 52,
  Identifier = 53,
  Absent = 54,
  Abs = 55,
  Acos = 56,
  Acosh = 57,
  Asin = 58,
  Asinh = 59,
  Atan = 60,
  Atanh = 61,
  AvgOverTime = 62,
  Ceil = 63,
  Changes = 64,
  Clamp = 65,
  ClampMax = 66,
  ClampMin = 67,
  Cos = 68,
  Cosh = 69,
  CountOverTime = 70,
  DaysInMonth = 71,
  DayOfMonth = 72,
  DayOfWeek = 73,
  DayOfYear = 74,
  Deg = 75,
  Delta = 76,
  Deriv = 77,
  Exp = 78,
  Floor = 79,
  HistogramCount = 80,
  HistogramFraction = 81,
  HistogramQuantile = 82,
  HistogramSum = 83,
  HoltWinters = 84,
  Hour = 85,
  Idelta = 86,
  Increase = 87,
  Irate = 88,
  LabelReplace = 89,
  LabelJoin = 90,
  LastOverTime = 91,
  Ln = 92,
  Log10 = 93,
  Log2 = 94,
  MaxOverTime = 95,
  MinOverTime = 96,
  Minute = 97,
  Month = 98,
  Pi = 99,
  PredictLinear = 100,
  PresentOverTime = 101,
  QuantileOverTime = 102,
  Rad = 103,
  Rate = 104,
  Resets = 105,
  Round = 106,
  Scalar = 107,
  Sgn = 108,
  Sin = 109,
  Sinh = 110,
  Sort = 111,
  SortDesc = 112,
  Sqrt = 113,
  StddevOverTime = 114,
  StdvarOverTime = 115,
  SumOverTime = 116,
  Tan = 117,
  Tanh = 118,
  Timestamp = 119,
  Time = 120,
  Vector = 121,
  Year = 122,
  MatrixSelector = 123,
  Duration = 124,
  NumberLiteral = 125,
  OffsetExpr = 126,
  ParenExpr = 127,
  StringLiteral = 128,
  SubqueryExpr = 129,
  UnaryExpr = 130,
  UnaryOp = 131,
  VectorSelector = 132,
  LabelMatchers = 133,
  LabelMatcher = 134,
  MatchOp = 135,
  EqlSingle = 136,
  EqlRegex = 137,
  NeqRegex = 138,
  StepInvariantExpr = 139,
  At = 140,
  AtModifierPreprocessors = 141,
  MetricName = 142;

export { Abs, Absent, AbsentOverTime, Acos, Acosh, Add, AggregateExpr, AggregateModifier, AggregateOp, And, Asin, Asinh, At, AtModifierPreprocessors, Atan, Atan2, Atanh, Avg, AvgOverTime, BinaryExpr, Bool, BoolModifier, Bottomk, By, Ceil, Changes, Clamp, ClampMax, ClampMin, Cos, Cosh, Count, CountOverTime, CountValues, DayOfMonth, DayOfWeek, DayOfYear, DaysInMonth, Deg, Delta, Deriv, Div, Duration, End, Eql, EqlRegex, EqlSingle, Exp, Floor, FunctionCall, FunctionCallBody, FunctionIdentifier, Group, GroupLeft, GroupRight, GroupingLabels, Gte, Gtr, HistogramCount, HistogramFraction, HistogramQuantile, HistogramSum, HoltWinters, Hour, Idelta, Identifier, Ignoring, Increase, Irate, LabelJoin, LabelMatcher, LabelMatchers, LabelName, LabelReplace, LastOverTime, LineComment, Ln, Log10, Log2, Lss, Lte, MatchOp, MatchingModifierClause, MatrixSelector, Max, MaxOverTime, MetricName, Min, MinOverTime, Minute, Mod, Month, Mul, Neq, NeqRegex, NumberLiteral, Offset, OffsetExpr, On, Or, ParenExpr, Pi, Pow, PredictLinear, PresentOverTime, PromQL, Quantile, QuantileOverTime, Rad, Rate, Resets, Round, Scalar, Sgn, Sin, Sinh, Sort, SortDesc, Sqrt, Start, Stddev, StddevOverTime, Stdvar, StdvarOverTime, StepInvariantExpr, StringLiteral, Sub, SubqueryExpr, Sum, SumOverTime, Tan, Tanh, Time, Timestamp, Topk, UnaryExpr, UnaryOp, Unless, Vector, VectorSelector, Without, Year, inf, nan, parser };
